import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.goToLogin.label",
    defaultMessage: "Go to login",
    description: "Button label go to login page",
  },
});
